import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import RirekishoEditor from 'builder/components/DocumentEditor/Japanese/RirekishoEditor'
import ShokumukeirekishoEditor from 'builder/components/DocumentEditor/ShokumukeirekishoEditor'
import ResumeEditor from 'builder/components/DocumentEditor'
import { TemplateName } from 'builder/components/Helper/constants'

const { Rirekisho, Shokumukeirekisho } = TemplateName
interface TemplateBuilderbjectKeys {
  [key: string]: typeof RirekishoEditor | typeof ShokumukeirekishoEditor
}

const templatBuilderMapping: TemplateBuilderbjectKeys = {
  [Rirekisho]: RirekishoEditor,
  [Shokumukeirekisho]: ShokumukeirekishoEditor,
}

export const useResumeEditor = () => {
  const templateName = useTypedSelector(state => state.resumeEditor?.resume?.template)

  return (templateName && templatBuilderMapping[templateName]) || ResumeEditor
}
